import {
  SectionHeader,
  SectionHeaderProps,
} from "../components/blocks/section-header";

interface ContentfulSectionHeaderProps extends SectionHeaderProps {
  __typename: string;
}

const test = ({ __typename }: ContentfulSectionHeaderProps): boolean =>
  __typename === "VinoData_SectionHeader";

const create = (data: ContentfulSectionHeaderProps): JSX.Element => {
  return <SectionHeader {...data} />;
};

export default { test, create };
